import { render, staticRenderFns } from "./otherstatistics.vue?vue&type=template&id=bac78ede"
import script from "./otherstatistics.vue?vue&type=script&lang=js"
export * from "./otherstatistics.vue?vue&type=script&lang=js"
import style0 from "./otherstatistics.vue?vue&type=style&index=0&id=bac78ede&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports